import { Controller } from '@hotwired/stimulus';
import { useEventListener } from 'stimulus-library/dist';

export default class extends Controller {
  static targets = ['button', 'form'];

  initialize() {
    this.showForm = this.showForm.bind(this);
  }

  connect() {
    useEventListener(this, this.buttonTarget, 'click', this.showForm);
  }

  showForm(event) {
    if (event) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
    this.buttonTarget.classList.add('hidden');
    this.formTarget.classList.remove('hidden');
    this.formTarget.querySelector('#save\\[new_collection\\]\\[title\\]').focus();
  }
}
